/**
 * Halka açık site için geçici anahtarlar.
 *
 * Buradaki bayraklar kaldırılmış değil **kapatılmış** şeyler içindir: kod
 * yerinde durur, tek satır `true` olunca geri gelir. Silmek yerine bayrak
 * kullanmanın sebebi, kapalı dururken de tip denetiminden geçmesi — `tsc -b`
 * gizlenmiş bölümü de derler, yani aylar sonra açıldığında çürümüş olmaz.
 */

/**
 * Destekçi Üyeliği'nin sitede görünüp görünmeyeceği. **Geçici olarak kapalı.**
 *
 * Kapalıyken: ana sayfadaki destekçi şeridi ve açılış teklifi bandı basılmaz,
 * üst çubuk ve alt bilgideki linkler düşer, `/supporter`, `/supporter/thanks`
 * ve `/vip` ana sayfaya yönlenir, profildeki "Destekçi Ol" kartı çıkmaz.
 *
 * **Mevcut destekçilerin kartı kapalıyken de durur** — abonelik hâlâ işliyor
 * ve iptal etme yolu profildeki o karttır; onu da gizlemek parasını ödemeye
 * devam eden birini üçüncü taraf bir panele mahkûm ederdi.
 *
 * Backend'e dokunmaz: `/api/home/supporter/*` uçları ve Whop mutabakatı
 * çalışmaya devam eder, sadece satın alma kapıları kapanır.
 */
export const SUPPORTER_ENABLED: boolean = false
